import QuantityPopover from '../QuantityPopover'
import QuantityBar from 'components/quantity-bar/quantity-bar'
import OrderedBadge from '../OrderedBadge'
import { OutgoingTransferDetail, PartsOrderedDetail, Reservation } from '../../../../../graphql'

import {
	EuiBadge,
	EuiFlexGroup,
	EuiFlexItem,
} from '@equipmentshare/ds2'

import styles from './quantity.module.css'

export type StorePart = {
	max?: number,
	total: number,
	threshold?: number,
	quantity: number,
	availableQuantity: number,
	partsOrdered?: number,
	partsOrderedDetails?: PartsOrderedDetail[],
	incomingPartsTransferQuantity?: number,
	part: {
		partClass: { description: string },
	},
	children: {
		store: { name: string },
		quantity: number,
		availableQuantity: number,
	}[],
	openReservations: Reservation[],
	outgoingTransferDetails?: OutgoingTransferDetail[],
}

export type QuantityColumnProps = {
	storePart: StorePart,
}

export default function QuantityColumn( { storePart }: QuantityColumnProps ) {
	const { availableQuantity, max, threshold, total } = storePart
	const childQuantities = storePart.children?.map( ( c ) => ( { name: c.store.name, quantity: c.availableQuantity } ) ) ?? []

	return (
		<EuiFlexGroup>
			<EuiFlexItem>
				<EuiFlexGroup direction="column" gutterSize="s">
					<EuiFlexItem>
						<div className={styles.gaugeContainer}>
							<div className={styles.qty}>{availableQuantity}</div>
							<div className={styles.quantityBarContainer}>
								<QuantityBar
									max={max ?? 1}
									threshold={threshold ?? 0}
									total={availableQuantity}
								/>
							</div>
						</div>
					</EuiFlexItem>
					<EuiFlexItem>
						<div className={styles.badgeContainer}>
							<OrderedBadge numOrdered={storePart.partsOrdered} orders={storePart.partsOrderedDetails} />
							{ storePart.incomingPartsTransferQuantity && (
								<EuiBadge>
									{storePart.incomingPartsTransferQuantity} in Transfer
								</EuiBadge>
							) }
						</div>
					</EuiFlexItem>
				</EuiFlexGroup>
			</EuiFlexItem>
			<EuiFlexItem>
				<QuantityPopover
					childQuantities={childQuantities}
					max={max}
					partDescription={storePart.part.partClass.description}
					quantity={availableQuantity}
					threshold={threshold}
					total={total ?? 0}
				/>
			</EuiFlexItem>
		</EuiFlexGroup>
	)
}
